import * as actionTypes from "../../../actions/actionTypes";
import { updateObject } from "../../../utility";

const initialState = {
  count: null,
  projects: null,
  pageS: 2,
  loading: null,
  error: null,
  showMenu: false,
  selectedClientProjectId: null,
};

const fetchClientProjectStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const fetchClientProjectSuccess = (state, action) => {
  return updateObject(state, {
    count: action.count,
    projects: action.projects,
    error: null,
    loading: false,
  });
};

const fetchClientProjectFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const createClientProjectStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const createClientProjectSuccess = (state, action) => {
  // let newArr = null;
  // if (state.pageS === state.projects.length) {
  //   let oldArr = [...state.projects];
  //   oldArr.pop();
  //   oldArr.unshift(action.newProject);
  //   newArr = [...oldArr];
  // } else {
  //   let oldArr = [...state.projects];
  //   oldArr.unshift(action.newProject);
  //   newArr = [...oldArr];
  // }

  return updateObject(state, {
    projects: state.projects.concat(action.newProject),
    msg: action.msg,
    count: state.count + 1,
    error: null,
    loading: false,
  });
};

const createClientProjectFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
    
  });
};

const deleteClientProjectStart = (state, action) => {
  return updateObject(state, { error: null, loading: true });
};

const deleteClientProjectSuccess = (state, action) => {
  const updatedArray = state.projects.filter(
    (project) => project._id !== action.projectId
  );
  // console.log(updatedArray);
  return updateObject(state, {
    projects: updatedArray,
    error: null,
    loading: false,
  });
};

const deleteClientProjectFail = (state, action) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const clearMsgClientProject = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
    msg: null,
  });
};

const selectClientProjectId = (state, action) => {
  return updateObject(state, {
    selectedClientProjectId: action.projectId,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CLIENT_PROJECTS_START:
      return fetchClientProjectStart(state, action);
    case actionTypes.FETCH_CLIENT_PROJECTS_SUCCESS:
      return fetchClientProjectSuccess(state, action);
    case actionTypes.FETCH_CLIENT_PROJECTS_FAIL:
      return fetchClientProjectFail(state, action);

    case actionTypes.CREATE_CLIENT_PROJECT_START:
      return createClientProjectStart(state, action);
    case actionTypes.CREATE_CLIENT_PROJECT_SUCCESS:
      return createClientProjectSuccess(state, action);
    case actionTypes.CREATE_CLIENT_PROJECT_FAIL:
      return createClientProjectFail(state, action);

    case actionTypes.DELETE_CLIENT_PROJECT_START:
      return deleteClientProjectStart(state, action);
    case actionTypes.DELETE_CLIENT_PROJECT_SUCCESS:
      return deleteClientProjectSuccess(state, action);
    case actionTypes.DELETE_CLIENT_PROJECT_FAIL:
      return deleteClientProjectFail(state, action);

    case actionTypes.CLEAR_MSG_CLIENT_PROJECT:
      return clearMsgClientProject(state, action);

    case actionTypes.SELECT_CLIENT_PROJECT:
      return selectClientProjectId(state, action);
    default:
      return state;
  }
};

export default reducer;
